module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE MP-3 PRE AMLIFIER.34bdd963.png";